import { ApiResponse } from '../types';
import { API_ENDPOINTS } from '../config/apiConfig';
import { apiFetch } from '../config/apiClient';

interface DashboardStats {
  channels: {
    total: number;
    trend: {
      value: number;
      isPositive: boolean;
    };
  };
  students: {
    total: number;
    trend: {
      value: number;
      isPositive: boolean;
    };
  };
  schools: {
    total: number;
    trend: {
      value: number;
      isPositive: boolean;
    };
  };
}

class DashboardService {
  private getHeaders(): HeadersInit {
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
    };

    const token = localStorage.getItem('token');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    return headers;
  }

  async getDashboardStats(academicYear?: number | null): Promise<ApiResponse<DashboardStats>> {
    try {
      const query = academicYear != null ? `?academicYear=${academicYear}` : '';
      const response = await apiFetch(`${API_ENDPOINTS.schoolApi}/dashboard/stats${query}`, {
        method: 'GET',
        headers: this.getHeaders(),
        credentials: 'include',
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to fetch dashboard stats');
      }

      return data;
    } catch (error) {
      throw new Error(error instanceof Error ? error.message : 'Failed to fetch dashboard stats');
    }
  }
}

const dashboardService = new DashboardService();
export default dashboardService;
